import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/enviroments';
import {  DataNewUser } from '../internal-users/interface/add-user.interface';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AddUsersService {
  constructor(private http: HttpClient) {}

  addUser(request: DataNewUser): Observable<any> {
    console.log(request);
    const endpoint = `${environment.apiUrl}/User`;
    return this.http.post<any>(endpoint, request);
  }
  getUser(): Observable<any> {
    const endpoint = `${environment.apiUrl}/User`;
    return this.http.get<DataNewUser>(endpoint);
  }
  getUserId(id: number): Observable<any> {
    
    const endpoint = `${environment.apiUrl}/User/${id}`;
    return this.http.get<DataNewUser>(endpoint);
  }
}
